var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.036,
    height: 15.036,
    viewBox: "0 0 15.036 15.036",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_29584",
    "data-name": "Path 29584",
    d: "M8.75,10.324v1.4A1.574,1.574,0,0,0,10.324,13.3h1.4A1.574,1.574,0,0,0,13.3,11.722v-1.4A1.574,1.574,0,0,0,11.722,8.75h-1.4A1.574,1.574,0,0,0,8.75,10.324Zm1.049,0a.525.525,0,0,1,.525-.525h1.4a.525.525,0,0,1,.525.525v1.4a.525.525,0,0,1-.525.525h-1.4a.525.525,0,0,1-.525-.525Z",
    transform: "translate(-3.505 -3.505)",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29585",
    "data-name": "Path 29585",
    d: "M1.25,2.824v1.4A1.574,1.574,0,0,0,2.824,5.8h1.4A1.574,1.574,0,0,0,5.8,4.222v-1.4A1.574,1.574,0,0,0,4.222,1.25h-1.4A1.574,1.574,0,0,0,1.25,2.824Zm1.049,0A.525.525,0,0,1,2.824,2.3h1.4a.525.525,0,0,1,.525.525v1.4a.525.525,0,0,1-.525.525h-1.4A.525.525,0,0,1,2.3,4.222Z",
    transform: "translate(-1.25 -1.25)",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29586",
    "data-name": "Path 29586",
    d: "M16.25,17.824v1.4A1.574,1.574,0,0,0,17.824,20.8h1.4A1.573,1.573,0,0,0,20.8,19.222v-1.4a1.574,1.574,0,0,0-1.574-1.574h-1.4a1.574,1.574,0,0,0-1.574,1.574Zm1.049,0a.525.525,0,0,1,.525-.525h1.4a.525.525,0,0,1,.525.525v1.4a.525.525,0,0,1-.525.525h-1.4a.525.525,0,0,1-.525-.525Z",
    transform: "translate(-5.76 -5.76)",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29587",
    "data-name": "Path 29587",
    d: "M6.775,4.8h9.091a.874.874,0,0,1,.874.874V8.121A.874.874,0,0,1,15.866,9h-2.1a.525.525,0,0,0,0,1.049h2.1a1.922,1.922,0,0,0,1.923-1.923V5.673A1.922,1.922,0,0,0,15.866,3.75H6.775a.525.525,0,1,0,0,1.049Z",
    transform: "translate(-2.753 -2.002)",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29588",
    "data-name": "Path 29588",
    d: "M9.467,16.5H3.173a.874.874,0,0,1-.874-.874V13.173a.874.874,0,0,1,.874-.874H7.02a.525.525,0,0,0,0-1.049H3.173A1.922,1.922,0,0,0,1.25,13.173v2.448a1.922,1.922,0,0,0,1.923,1.923H9.467a.525.525,0,1,0,0-1.049Z",
    transform: "translate(-1.25 -4.257)",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29589",
    "data-name": "Path 29589",
    d: "M18.544,12.2l-1.027-1.028,1.027-1.028A.524.524,0,1,0,17.8,9.4l-1.4,1.4a.524.524,0,0,0,0,.741l1.4,1.4a.524.524,0,0,0,.741-.741Z",
    transform: "translate(-5.76 -3.655)",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29590",
    "data-name": "Path 29590",
    d: "M12.145,20.443l1.4-1.4a.524.524,0,0,0,0-.741l-1.4-1.4a.524.524,0,1,0-.741.741l1.027,1.028L11.4,19.7a.524.524,0,0,0,.741.741Z",
    transform: "translate(-4.257 -5.91)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflow);
export default __webpack_public_path__ + "static/media/workflow.8b3b8fd0d31882dc1ca8e9908ab2e2d6.svg";
export { ForwardRef as ReactComponent };